<!-- 544px and less, will hide palceholder and show label instead-->
<form name="theForm" novalidate class="general-form">    
    <div> <!-- policy start date -->
        <label 
            for="txt-start-date"
            [class.visible-label]="isMobileDevice()">
            {{'HOMEOWNERS.START_DATE_PLACEHOLDER' | translate}}
        </label>
        <div class="input-group mb-4">
            <button 
                class="btn btn-tertiary mx-0" 
                type="button"
                (click)="calanderButtonClicked(d)"
                attr.aria-label="{{'HOMEOWNERS.START_DATE_PLACEHOLDER' | translate}}">
                    <i class="fas fa-calendar-alt" aria-hidden="true"></i>
            </button>
            <input 
                id="txt-start-date" 
                autocomplete="none"
                name="startdate" 
                type="text"
                [title]="'HOMEOWNERS.POLICY_START' | translate"
                placeholder="{{'HOMEOWNERS.QUESTIONS.YEAR_BUILT_PLACEHOLDER' | translate }}"
                class="form-control"
                [ngClass]="{'has-error' : quoterRequestError.startDateOutOfRange || (quoterRequestError.startDateNotSet && startDateTouched)}"
                [placeholder]="'HOMEOWNERS.START_DATE_PLACEHOLDER'| ceaPlaceholder: !isMobileDevice() | translate"
                [minDate]="getMinDateVal()"
                [maxDate]="getMaxDateVal()"
                firstDayOfWeek="7"
                attr.aria-label="{{'HOMEOWNERS.START_DATE_PLACEHOLDER' | translate}}"
                [(ngModel)]="quoterRequest.StartDate" ngbDatepicker #d="ngbDatepicker"
                (click)="calanderFieldClicked(d)"
                (ngModelChange)="validateSetStartDate(quoterRequest.StartDate)" />
            <app-cea-help-button 
                [stype]="'input'"
                [title]="'HOMEOWNERS.HELP.POLICY_START.TITLE'"
                [text1]="'HOMEOWNERS.HELP.POLICY_START.TEXT'">
            </app-cea-help-button>       
            <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>         
        </div>
        <div class="alert alert-danger"
            *ngIf="quoterRequestError.startDateOutOfRange"
            [innerHTML]="dateRangeErrorMessage">
        </div>
        <div class="alert alert-danger"
            *ngIf="quoterRequestError.startDateNotSet && startDateTouched"
            [innerHTML]="'ERRORS.SELECT_POLICY_YEAR_FIRST' | translate">
        </div>
    </div>

    <div> <!-- New or Renewal? -->
        <label for="ddl-renewal-or-new"
            [class.visible-label]="isMobileDevice()">
            {{'HOMEOWNERS.FRF_QUOTE_TYPE.QUESTION' | translate}}
        </label>
        <div class="input-group mb-4">
            <select 
                id="ddl-renewal-or-new" 
                class="form-select"
                [ngClass]="{'has-error' : quoterRequestError.renewalIsEmpty}"
                [(ngModel)]="quoterRequest.IsRenewal"
                (change)="validateRenewal()"
                attr.aria-label="{{'HOMEOWNERS.FRF_QUOTE_TYPE.QUESTION' | translate}}">
                <option 
                    [ngValue]="null"
                    disabled
                    [selected]="quoterRequest.IsRenewal === null">
                    {{'HOMEOWNERS.FRF_QUOTE_TYPE.QUESTION' | ceaPlaceholder: !isMobileDevice() | translate }}
                </option>
                <option value="true">
                    {{'HOMEOWNERS.FRF_QUOTE_TYPE.RENEWAL'| translate }}
                </option>
                <option value="false">
                    {{'HOMEOWNERS.FRF_QUOTE_TYPE.NEW'| translate }}
                </option>
            </select>
            <app-cea-help-button 
                [stype]="'input'"
                [title]="'HOMEOWNERS.QUESTIONS.HELP.TYPE_QUOTE.TITLE'"
                [text1]="'HOMEOWNERS.QUESTIONS.HELP.TYPE_QUOTE.TEXT'">
            </app-cea-help-button> 
            <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>    
        </div>
        <div class="alert alert-danger"
            *ngIf="quoterRequestError.renewalIsEmpty"
            [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">
        </div>  
    </div>

    
    <div> <!-- insurance company -->
        <label 
            for="ddl-participating-insurer"
            [class.visible-label]="isMobileDevice()">
            {{'HOMEOWNERS.INSURANCE_COMPANY_PLACEHOLDER' | translate }}
        </label>
        <div class="input-group mb-4">
            <select id="ddl-participating-insurer" 
                    name="participatingInsurer"
                    class="form-select" 
                    [ngClass]="{'has-error' : quoterRequestError.ParticipatingInsurerIsEmpty}"
                    [(ngModel)]="quoterRequest.ParticipatingInsurer"
                    (click)="participatingInsurerOpened()" 
                    (change)="validateInsurer()"
                    attr.aria-label="{{'HOMEOWNERS.INSURANCE_COMPANY_PLACEHOLDER' | translate}}">
                <option value="" disabled>
                    {{'HOMEOWNERS.INSURANCE_COMPANY_PLACEHOLDER' | ceaPlaceholder: !isMobileDevice() | translate }}
                </option>
                <option *ngIf="!quoterRequestError.participatingInsurerDateNeeded && defaultSetting" [ngValue]="defaultSetting">
                    {{defaultSetting}}
                </option>
                <ng-container>
                    <option *ngFor="let item of validPiNames" [ngValue]="item | translate"
                            title="{{item.replace('-2016', '') | translate}}">
                        {{ item.replace('-2016', '') | translate}}
                    </option>
                </ng-container>
            </select>
            <app-cea-help-button 
                [stype]="'input'"
                [title]="'HOMEOWNERS.HELP.CHOOSE_INSURANCE_HELP.TITLE'"
                [text1]="'HOMEOWNERS.HELP.CHOOSE_INSURANCE_HELP.TEXT'">
            </app-cea-help-button>
            <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>    
        </div>
        <div class="alert alert-danger"
            *ngIf="quoterRequestError.ParticipatingInsurerIsEmpty"
            [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">
        </div> 
     </div>

    
    <div class="mb-3"> <!-- Address 1 -->
        <div
            [ngClass]="quoterRequestError.street || quoterRequestError.streetIsEmpty? 'has-error' : ''"
            app-autocomplete
            (setAddress)="getAddress($event)"
            adressType="geocode"
            [setSavedAddress]="quoterRequest.StreetAddress"
            (setAddressError)="setAddressError($event)"
            [isMobileView]="isMobileDevice()"
            (setAddressPickedFromBrowser)="setAddressPickedFromBrowser($event)">
        </div>
        <div class="alert alert-danger"
            *ngIf="!quoterRequest.StreetAddress && quoterRequestError.street"
            [innerHTML]="'ERRORS.FILL_OUT_FIELD' | translate">
        </div>
        <div class="alert alert-danger"
            *ngIf="quoterRequestError.streetIsEmpty"
            [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">            
        </div>
    </div>  

    <div> <!-- Address 2 -->
        <label 
            for="txt-address2"
            [class.visible-label]="isMobileDevice()">
            {{'HOMEOWNERS.ADDRESS2_PLACEHOLDER' | translate }}
        </label>
        <div class="input-group mb-4">
            <input
                id="txt-address2"
                name="address2"
                class="form-control"
                type="text"
                placeholder="{{'HOMEOWNERS.ADDRESS2_PLACEHOLDER' | ceaPlaceholder: !isMobileView | translate }}"
                attr.aria-label="{{'HOMEOWNERS.ADDRESS2_PLACEHOLDER' | translate}}"
                [(ngModel)]="quoterRequest.Address2" />
            <span class="input-group-text input-group-text-required" aria-hidden="true"></span>
        </div>
    </div>

    <div>
        <!-- City -->
        <label for="txt-city"
               [class.visible-label]="isMobileDevice()">
            {{'HOMEOWNERS.CITY_PLACEHOLDER' | translate }}
        </label>
        <div class="input-group mb-4">
            <input id="txt-city"
                   name="city"
                   class="form-control"
                   type="text"
                   placeholder="{{'HOMEOWNERS.CITY_PLACEHOLDER' | ceaPlaceholder: !isMobileDevice() | translate }}"
                   attr.aria-label="{{'HOMEOWNERS.CITY_PLACEHOLDER' | translate}}"
                   [(ngModel)]="quoterRequest.City"
                   (change)="checkModelValue()"
                   (ngModelChange)="checkModelValue()"/>
            <span class="input-group-text input-group-text-required" aria-hidden="true"></span>
        </div>
        <div class="alert alert-danger"
             *ngIf="quoterRequestError.city"
             [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">
        </div>
    </div>

    <div> <!-- State -->
        <label 
            for="txt-state"
            [class.visible-label]="isMobileDevice()">
            {{'HOMEOWNERS.STATE_PLACEHOLDER' | translate }}
        </label>
        <div class="input-group mb-4">
            <input 
                id="txt-state"
                name="state"
                class="form-control"
                type="text"
                attr.aria-label="{{'HOMEOWNERS.STATE_PLACEHOLDER' | translate}}"
                placeholder="{{'HOMEOWNERS.STATE_PLACEHOLDER'| ceaPlaceholder: !isMobileDevice() | translate }}"
                [(ngModel)]="quoterRequest.AddressState"
                (change)="checkModelValue()"
                (ngModelChange)="checkModelValue()"
                />
            <span class="input-group-text input-group-text-required" aria-hidden="true"></span>
        </div>
        <div class="alert alert-danger"
            *ngIf="quoterRequestError.AddressStateIsIncorrect"
            [innerHTML]="'ERRORS.VALID_ADDRESS_STATE' | translate">
        </div>
    </div>

    <div> <!-- Zip -->
        <label 
            for="txt-zip"
            [class.visible-label]="isMobileDevice()">
            {{'HOMEOWNERS.ZIPCODE_PLACEHOLDER' | translate }}
        </label>
        <div class="input-group mb-4">
            <input 
                id="txt-zip"
                name="zipcode"
                class="form-control"
                [ngClass]="{'has-error' : quoterRequestError.enterValidZipCode === true || quoterRequestError.zipCodeIsEmptyOrlengthIncorrect}"
                type="text"
                (ngModelChange)="validateZipCode($event, false)" 
                placeholder="{{'HOMEOWNERS.ZIPCODE_PLACEHOLDER'| ceaPlaceholder: !isMobileDevice() | translate }}"
                attr.aria-label="{{'HOMEOWNERS.ZIPCODE_PLACEHOLDER' | translate}}"
                [(ngModel)]="quoterRequest.ZipCode"
                numbersOnly
                />
            <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>    
        </div>
        <div class="alert alert-danger"
            *ngIf="quoterRequestError.zipCodeIsEmptyOrlengthIncorrect"
            [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">
        </div>
        <div class="alert alert-danger"
            *ngIf="quoterRequestError.zipCodeIsEmptyShowLink" 
            [innerHtml]="('ERRORS.INVALID_ZIPCODE' | translate).replace('[link]',zipCodeErrorMessage)">
        </div>
    </div>

    <div *ngIf="policytype === page.condo"> <!-- Fair market value -->
        <fieldset class="question-fieldset mb-4">
            <legend class="question-legend">
                {{'CONDO.FAIR_MARKET' | translate }}
            </legend>
            <div class="question-fieldset-content d-flex justify-content-end">
                <div class="form-check form-check-inline">
                    <input 
                        id="rad-fair-market-value-yes"
                        class="form-check-input" 
                        type="radio" 
                        [name]="'radiogroup' + groupkey"
                        [(ngModel)]="quoterRequest.IsFairMarketValueOver135k"
                        [value]="true"
                        />
                    <label 
                        for="rad-fair-market-value-yes"
                        class="form-check-label">
                        {{'GLOBAL.YES' | translate }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <input 
                        id="rad-fair-market-value-no"
                        class="form-check-input" 
                        type="radio" 
                        [name]="'radiogroup' + groupkey"
                        [(ngModel)]="quoterRequest.IsFairMarketValueOver135k"
                        [value]="false"
                        />
                    <label 
                        for="rad-fair-market-value-no"
                        class="form-check-label">
                        {{'GLOBAL.NO' | translate }}
                    </label>
                </div>
                <app-cea-help-button ng-if="helpSlug"
                    [stype]="'radio'"
                    [title]="'CONDO.HELP.FAIR_MARKET.TITLE'"
                    [text1]="'CONDO.HELP.FAIR_MARKET.TEXT'">
                </app-cea-help-button>
            </div>
        </fieldset>
    </div>

    <div class="row action-buttons">
        <div class="col-12 col-md-6">
            <button class="btn btn-tertiary w-100 mb-3" 
                id="btn-back"
                (click)="goBack()">
                <i class="fas fa-arrow-left" aria-hidden="true"></i>
                {{'GLOBAL.BACK_BUTTON' | translate }}
            </button>
        </div>
        <div class="col-12 col-md-6">
            <button class="btn btn-tertiary w-100 mb-3" 
                id="btn-startedmh" 
                *ngIf="policytype === page.mobilehome || policytype === page.homeowner"
                (click)="verifyAndSubmit()">
                {{'HOMEOWNERS.GET_STARTED_BUTTON' | translate }}
            </button>
            <button class="btn btn-tertiary w-100 mb-3" 
                id="btn-startedrc"
                *ngIf="policytype === page.condo || policytype === page.renter" (click)="getEstimate()">
                <i *ngIf="showSpin" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                {{'HOMEOWNERS.QUESTIONS.GET_ESTIMATE_BUTTON' | translate }}
            </button>
        </div>
    </div>
</form>
